<template>
  <div :class="size" class="card-template-container">
    <div class="head">
      <div class="title">{{ title }}</div>
      <slot name="action"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>


<style lang="less" scoped>
.card-template-container {
  background: white;
  padding: 20px 30px 10px;

  &.large {
    flex: 95;
    flex-shrink: 0;
    overflow: hidden;
  }

  &.small {
    flex: 52;
    flex-shrink: 0;
    overflow: hidden;
  }

  .head {
    height: 40px;
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #ebebeb;
    margin-bottom: 10px;

    .title {
      color: #333333;
      font-weight: 600;
      font-size: 18px;
    }
  }
}
</style>
